import gql from 'graphql-tag';

const rejectPendingOfferMutation = gql`
  mutation rejectPendingOffer($rejectInput: RejectPendingOfferInput!) {
    rejectPendingOffer(input: $rejectInput) {
      success
      errors
    }
  }
`;

export default rejectPendingOfferMutation;
